import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Button } from './ui/Button';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  const {
    scrollY
  } = useScroll();
  const y = useTransform(scrollY, [0, 500], [0, 150]);
  const opacity = useTransform(scrollY, [0, 300], [1, 0]);
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section id="home" className="relative h-screen w-full overflow-hidden" data-id="element-192">
      {/* Background Image with Parallax */}
      <motion.div style={{
      y
    }} className="absolute inset-0 z-0" data-id="element-193">
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-[#0A5F8F]/90 z-10" data-id="element-194" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fQE8U5PczMXz5vmJNexzo8/939A3565.jpg" alt="Beach Club Maagan - Kayaks and SUPs at the shore" className="w-full h-full object-cover" data-id="element-195" />
      </motion.div>

      {/* Content */}
      <div className="relative z-20 h-full flex flex-col items-center justify-center text-center px-4 pt-20" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl mx-auto space-y-8" data-id="element-197">
          <motion.h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight drop-shadow-lg" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} data-id="element-198">
            ביץ׳ קלאב
            <br data-id="element-199" />
            מועדון חתירה וגלישה
            <br data-id="element-200" />
            <span className="text-blue-200" data-id="element-201">בחוף מעגן </span>
          </motion.h1>

          <motion.p className="text-xl md:text-2xl text-white/90 font-light max-w-2xl mx-auto" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.4,
          duration: 0.8
        }} data-id="element-202">
            הבית שלכם בכנרת. חוויה ימית מקצועית באווירה משפחתית.
          </motion.p>

          <motion.div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6,
          duration: 0.8
        }} data-id="element-203">
            <Button variant="primary" size="lg" className="w-full sm:w-auto bg-[#0D7AB8] hover:bg-[#0A5F8F] border-none shadow-lg shadow-blue-900/20" onClick={() => scrollToSection('contact')} data-id="element-204">
              הצטרפו אלינו
            </Button>
            <Button variant="outline" size="lg" className="w-full sm:w-auto backdrop-blur-sm" onClick={() => scrollToSection('activities')} data-id="element-205">
              גלו את הפעילויות
            </Button>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div style={{
      opacity
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 text-white flex flex-col items-center gap-2 cursor-pointer" animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 2
    }} onClick={() => scrollToSection('activities')} data-id="element-206">
        <span className="text-sm font-medium tracking-wider opacity-80" data-id="element-207">
          גלו עוד
        </span>
        <ChevronDown className="w-6 h-6" data-id="element-208" />
      </motion.div>
    </section>;
}